import { render, staticRenderFns } from "./ModalDialogTrigger.vue?vue&type=template&id=8cc8b1c2&"
import script from "./ModalDialogTrigger.vue?vue&type=script&lang=js&"
export * from "./ModalDialogTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports